import { IntermediaryIdentityDto } from "tasksBoard/service/api/IntermediaryIdentityDto";

export class IntermediaryDisplayNameFromResponse {
    constructor(private intermediaryIdentityFromResponse: IntermediaryIdentityDto) {}

    displayName(): string | undefined {
        let result = undefined;

        let identifiers = [];
        if (this.intermediaryIdentityFromResponse?.name) {
            identifiers.push(this.intermediaryIdentityFromResponse?.name);
        }
        if (this.intermediaryIdentityFromResponse?.businessSymbol) {
            identifiers.push(this.intermediaryIdentityFromResponse?.businessSymbol);
        }

        if (identifiers.length > 0) {
            result = identifiers.join(" / ");
        }

        return result;
    }
}
